import { render, staticRenderFns } from "./EditCoffeeTree.vue?vue&type=template&id=4c583f85"
import script from "./EditCoffeeTree.vue?vue&type=script&lang=js"
export * from "./EditCoffeeTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports